// extracted by mini-css-extract-plugin
export default {"formHeading":"cI-z","form":"dI-z","submitBtn":"eI-z","disabled":"fI-z","input":"gI-z","error":"hI-z","submitMsg":"iI-z","signIn":"jI-z"};